
import { defineComponent } from 'vue';
import AIDialog from '@/components/AIDialog.vue';

export default defineComponent({
  components: {
    AIDialog,
  },
});
